

const router_modular = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'landingPage',
        component: () => import('@/views/landingPage.vue')
    },
    {
        path: '/about_us',
        name: 'aboutUs',
        component: () => import('@/views/aboutUs/index.vue')
    },
]
export default router_modular